import React, { useContext } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import logo from "./../../assets/agencyIQ_Logo.png";
import { UserContext } from "../UserContext";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingLeft: theme.spacing(6),
  },
  ctaButton: {
    padding: 12,
    background: "#041E42",
    color: "white",
    borderRadius: 4,
    "&:hover": {
      background: "#28367B",
      color: "white",
    },
    marginTop: theme.spacing(4),
  },
  heading: {
    fontSize: 34,
    fontWeight: "bold",
    color: "#28367B",
    marginBottom: 10,
  },
  container: {
    marginTop: 20,
    width: 750,
    height: 300,
    background: "white",
    display: "flex",
    margin: "auto",
    borderRadius: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  card: {
    marginTop: 10,
    width: "100%",
    height: "auto",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logo: {
    height: 80,
  },
  content: {
    margin: 10,
    textAlign: "center",
  },
  subHeading: {
    margin: 10,
    fontSize: 18,
    textAlign: "center",
    lineHeight: 2,
  },
}));

export function UnavailableFeatureForSuperuser(props) {
  const classes = useStyles();
  const { user } = useContext(UserContext);
  const isPowerUser = user.isPowerUser();

  return (
    <Container className={classes.container}>
      <div className={classes.card}>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src={logo} alt="AgencyIQ" />
        </div>

        <div className={classes.content}>
          <Typography
            variant="h4"
            className={classes.heading}
            style={{ fontWeight: 900 }}
          >
            {!isPowerUser ? "This feature is available only for member agencies!" : "This feature is not available for your role!"}
          </Typography>  
        </div>
      </div>
    </Container>
  );
}

UnavailableFeatureForSuperuser.propTypes = {
  isBillingAllowed: PropTypes.bool.isRequired,
  feature: PropTypes.string,
};
